/*
  Send a completed year/make/model search to the Searchanise results page.

  The EasySearch app builds its own destination from the fitment data it was
  given, which is a collection URL: /collections/all/<vehicle-tag>. Search on
  this store runs through Searchanise on /pages/search-results-page, which
  filters on that same tag through its rb_tags parameter, so the button is
  pointed there instead.

  The app navigates by letting the browser follow the button's href once its
  inline onclick (easysearch.saveSearchParams) has returned. Rewriting the
  href from a capturing listener therefore changes the destination and
  nothing else: the app's handler still runs, and it still reads its tags
  from the holder's esparams rather than from the URL, so the cookies it
  keeps for the garage and for pre-selecting the widget stay correct.

  The results page comes from a data attribute on the widget wrapper, set by
  the Hero section. With no attribute, or a blank one, the app keeps its own
  destination.
*/
(() => {
  // The tag the app matched. esparams is set by the app on every change and
  // is authoritative; the href can lag a selection behind, so it is only the
  // fallback. Multiple tags are joined with + when universal products are on.
  const tagsFor = (link, href) => {
    const holder = link.closest('.easysearch-holder');
    const fromApp = holder && holder.esparams && holder.esparams.tags;
    if (fromApp) return fromApp.split('+').filter(Boolean);

    const path = href.split('?')[0].replace(/\/+$/, '');
    const slug = path.slice(path.lastIndexOf('/') + 1);
    return slug ? [slug] : [];
  };

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!target || !target.closest) return;

      const link = target.closest('a.easysearch-btn-search');
      if (!link || link.hasAttribute('disabled')) return;

      const scope = link.closest('[data-fitment-results-url]');
      const base = scope && scope.dataset.fitmentResultsUrl;
      if (!base) return;

      // Until the last select is answered the app parks the button on
      // javascript:void(0), which is not ours to redirect.
      const href = link.getAttribute('href') || '';
      if (href.charAt(0) !== '/') return;

      const tags = tagsFor(link, href);
      if (!tags.length) return;

      const url = new URL(base, window.location.origin);
      url.searchParams.set('page', '1');
      url.searchParams.delete('rb_tags');
      tags.forEach((tag) => url.searchParams.append('rb_tags', tag));

      const destination = url.pathname + url.search;
      link.setAttribute('href', destination);

      // Autosubmit mode navigates from esparams instead of the href, and the
      // app stores this URL as the garage's last search either way.
      const holder = link.closest('.easysearch-holder');
      if (holder && holder.esparams) holder.esparams.url = destination;
    },
    true
  );
})();
